module.exports = __webpack_public_path__ + "static/media/football.12aa8672.JPG";